export const LOCAL_TRIP_COUNTRY_ID = '78';
